import React, { useMemo } from "react";

import { useLocation } from "react-router-dom";
import queryString from "query-string";

export const useAividUrlParams = () => {
  const { search } = useLocation();
  const params = useMemo(
    () => queryString.parse(search, { arrayFormat: "bracket" }),
    [search]
  );
  return params;
};
